import { withApp } from "@/components/App"
import New from "@/onboarding/features/component_library/components/New"

export default withApp(New)
